import React from 'react'
import { useState } from 'react';
import './Chalan.css'
import ChalanForm from './ChalanForm';

function GenerateChalan() {

      return (
        <div className="">
          <ChalanForm/>
        </div>
      );
}

export default GenerateChalan